import { hide, show, toggle } from "slidetoggle";

export const slideToggleDefaults = {
  miliseconds: 300,
  transitionFunction: 'linear',
};
export const slideToggle = (el, opts = {}) => {
  toggle(el, { ...slideToggleDefaults, ...opts });
};
export const slideUp = (el, opts = {}) => {
  hide(el, { ...slideToggleDefaults, ...opts });
};
export const slideDown = (el, opts = {}) => {
  show(el, { ...slideToggleDefaults, ...opts });
};
export const isHidden = (el) => el.offsetParent === null;

export const SlideToggleContainer = () => ({
  "@slideToggle"() {
    this.slideOpen = ! this.slideOpen;
  },
  "@slideUp"() {
    this.slideOpen = true;
  },
  "@slideDown"() {
    this.slideOpen = false;
  },
  "x-init"() {
    const slideOpts = {
      miliseconds: this.$data.duration || 300,
    };
    this.slideOpen = !isHidden(this.$el, slideOpts);

    this.$watch('slideOpen', (openValue) => {
      // Cancel any in-flight slide first. Otherwise a fast close→open (e.g.
      // scrolling past the pencil-bar threshold within the animation window)
      // lets the previous animation's `finish` handler set `display:none`
      // *after* the new one has started, leaving the element stuck hidden.
      this.$el.getAnimations().forEach((animation) => animation.cancel());
      if (openValue) slideDown(this.$el, slideOpts);
      else slideUp(this.$el);
    });
  }
});

document.addEventListener('alpine:init', () => {
  window.Alpine?.bind('SlideToggleContainer', SlideToggleContainer);
});
